import React from 'react';
import MetaTags from '@/components/meta/MetaTags';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

const DropsCancel: React.FC = () => {
  const navigate = useNavigate();
  return (
    <main className="container mx-auto max-w-2xl px-4 py-10 text-center">
      <MetaTags title="Drops – Checkout Canceled" description="Your checkout was canceled. You can resume anytime." />
      <h1 className="text-2xl md:text-3xl font-bold mb-3">Checkout Canceled</h1>
      <p className="text-muted-foreground mb-6">You can adjust your collection and try again whenever you are ready.</p>
      <div className="flex gap-3 justify-center">
        <Button onClick={() => navigate('/drops')}>Back to Dashboard</Button>
        <Button variant="secondary" onClick={() => navigate('/profile')}>Go to Profile</Button>
      </div>
    </main>
  );
};

export default DropsCancel;
